import ahoy from "ahoy.js";
import { keepAhoyRequestsOutOfGlobalEvents } from "./ahoy_requests";

const visitsUrl = "/ancient-frost-1484/visits";
const eventsUrl = "/ancient-frost-1484/events";

ahoy.configure({
  visitsUrl,
  eventsUrl,
  cookieDomain: "honeybadger.io",
  withCredentials: true,
});

keepAhoyRequestsOutOfGlobalEvents(window.jQuery, [visitsUrl, eventsUrl]);

document.addEventListener("turbo:load", () => {
  ahoy.trackView();
});
